import { useState, useEffect } from 'react';
import { getFirestore, doc, onSnapshot } from 'firebase/firestore';
import { getApp } from 'firebase/app';

function todayIST() {
  return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });
}

/**
 * useWorkSession — real-time listener for today's attendance record.
 * Returns { session, loading } where session has:
 *   session.isCheckedIn  — true if record exists and isOpen === true
 *   session.isComplete   — true if record exists and isOpen === false
 *   session.record       — raw Firestore doc data (or null)
 */
export function useWorkSession(uid) {
  const [record,  setRecord]  = useState(undefined); // undefined = loading
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid) { setRecord(null); setLoading(false); return; }
    const db  = getFirestore(getApp());
    const today = todayIST();
    const ref = doc(db, 'attendance', uid, 'records', today);
    const unsub = onSnapshot(ref, snap => {
      setRecord(snap.exists() ? snap.data() : null);
      setLoading(false);
    }, () => { setRecord(null); setLoading(false); });
    return unsub;
  }, [uid]);

  const session = {
    record,
    isCheckedIn: record?.isOpen === true,
    isComplete:  record != null && record.isOpen === false,
    notCheckedIn: record === null,
  };

  return { session, loading };
}
